import {ReactElement} from "react"
import {useParams} from "react-router-dom"
import {useTranslate} from "@refinedev/core"
import {DeleteButton, EditButton, Show} from "@refinedev/antd"
import {Button, Col, Form, Row} from "antd"
import {EyeOutlined} from "@ant-design/icons"
import {getActivity} from "../../services/ServiceActivity"
import {getClients} from "../../services/ServiceClient"
import {getAuthentications} from "../../services/ServiceAuthentication"
import {getTypes} from "../../services/ServiceType"
import ClientCard from "../../components/cards/ClientCard"
import InstanceCard from "../../components/cards/InstanceCard"
import {Custom} from "../../utils/refineUtils"

export default function ActivityShow(): ReactElement | null {
    const translate = useTranslate()
    const {id} = useParams()
    const {activity, isActivityLoading} = getActivity(id ?? '')
    const {clients, isClientsLoading} = getClients()
    const {authentications, isAuthenticationsLoading} = getAuthentications()
    const {types, isTypesLoading} = getTypes()

    // @ts-ignore
    const headerButtons = () =>
        <>
            <a href={activity?.url} target="_blank">
                <Button type="default" icon={<EyeOutlined/>}>{translate("buttons.preview")}</Button>
            </a>
            <DeleteButton resource="activity"
                          confirmTitle={translate('buttonsProps.delete.confirmTitle')}
                          confirmOkText={translate('buttonsProps.delete.confirmOkText')}
                          confirmCancelText={translate('buttonsProps.delete.confirmCancelText')}
                          recordItemId={id}/>
            <EditButton type="primary">{translate("buttons.edit")}</EditButton>
        </>

    return <Show title={activity?.title} headerButtons={headerButtons}
                 isLoading={isActivityLoading || isClientsLoading || isAuthenticationsLoading || isTypesLoading}>
        <Form name="show" initialValues={activity}>
            <Row>
                <Col span={12}>
                    <Row style={{marginBottom: 10}}>
                        <Col span={12}>
                            <Custom.IconTitle icon="user" label="activity.author"
                                              value={activity?.author ?? translate('activity.noAuthor')}/>
                        </Col>
                        <Col span={12}>
                            <Custom.IconTitle icon="clock-circle" label="activity.duration"
                                              value={Custom.formate(activity?.duration ?? 0, translate('activity.noDuration'))}/>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: 10}}>
                        <Col>
                            <Custom.IconTitle icon="align-left" label="activity.description"
                                              value={activity?.description ?? translate('activity.noDescription')}/>
                        </Col>
                    </Row>
                    <Row style={{marginBottom: 10}}>
                        <Col>
                            <Custom.IconTitle icon="login" label="activity.authentications"/>
                            {activity?.authentications.map((item) => {
                                const auth = authentications?.find(auth => auth.id === item)!
                                const type = types?.find(type => type.id === auth.type)!
                                return <Custom.AuthInfo auth={auth} type={type} key={item}/>
                            })}
                            {activity?.authentications?.length === 0 &&
                                <Row>{translate('activity.noAuthentication')}</Row>}
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <Custom.IconTitle icon="crown" label="activity.clients"/>
                    <Row gutter={[16, 16]}>
                        {activity?.clients?.map((client, index: number) => (
                            <ClientCard index={index} key={client.id} config={client.config}
                                        client={{...clients?.find(cl => cl.id === client.id)!, ...client}}/>
                        ))}
                    </Row>
                    {!activity?.clients?.length && <Row>{translate('activity.noClient')}</Row>}
                </Col>
            </Row>
            <Col>
                <Custom.IconTitle icon="calendar" label="activity.instances"/>
                <Row gutter={[16, 16]}>
                    {activity?.instances?.map((instance, index: number) => (
                        <InstanceCard span={8} key={index} instance={instance} activity={activity}/>
                    ))}
                </Row>
                {!activity?.instances?.length && <Row>{translate('activity.noInstance')}</Row>}
            </Col>
        </Form>
    </Show>
}
